import { ButtonProps } from "@/entities/atoms/Button/Button.types";
import styles from "./Button.module.css";

/**
 * Clickable button for executing actions.
 */
export function Button({ variant = "standard", ...rest }: ButtonProps) {
  return (
    <button
      className={`${styles.root} ${variant === "transparent" ? styles.transparent : ""}`}
      data-testid={Button.displayName}
      {...rest}
    />
  );
}
Button.displayName = "Button";
